module.exports = __webpack_public_path__ + "static/media/empty_notification_page.20c48d70.png";